<template>
 <div>  
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="xs" title="Descargar acta" hide-footer  hide-header-close no-close-on-backdrop>
    <b-card-body>
    <b-row>      
      <b-col md="6">
        <b-form-group >
          <label>Folio</label>
          <b-form-input           
            v-model="descarga.folio"
            placeholder="Folio"
            :class="{invalid_input: $v.descarga.folio.$error}"
          ></b-form-input>
          <label v-if="$v.descarga.folio.$error && !$v.descarga.folio.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col> 
      <b-col md="6">
        <b-form-group >
          <label>Vigencia</label>
          <b-form-input           
            v-model="descarga.vigencia"
            type="date"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group >
          <label>Uso de suelo</label>
          <b-form-input           
            v-model="descarga.giro"
            placeholder="Uso de suelo"
            :class="{invalid_input: $v.descarga.giro.$error}"
          ></b-form-input>
          <label v-if="$v.descarga.giro.$error && !$v.descarga.giro.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
     
       
      
   
        <b-col md="12">
        <b-form-group >
          <label >Se considera</label>
          <b-form-input           
            v-model="descarga.seConsidera"
            :class="{invalid_input: $v.descarga.seConsidera.$error}"
            placeholder="Ejemplo: Favorable"
          ></b-form-input>
          <label v-if="$v.descarga.seConsidera.$error && !$v.descarga.seConsidera.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group >
          <label >Leyenda del municipio</label>
          <b-form-input           
            v-model="descarga.pie"
            :class="{invalid_input: $v.descarga.pie.$error}"
            
          ></b-form-input>
          <label v-if="$v.descarga.pie.$error && !$v.descarga.pie.required" class="error-text" >
            <i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>      
      <b-col style="text-align: center">
        <b-button @click="$emit('cancelar')" :disabled="enviando">Cancelar</b-button>
        <br />
      </b-col>
      <b-col style="text-align: center">
        <b-button variant="primary" @click="guardar()" :disabled="enviando">Descargar</b-button>
      </b-col>
     
    </b-row>
    </b-card-body>

    </b-modal>

  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Loader from '../Loader'
const { DateTime } = require("luxon");
export default {
 components: { Loader },
  
  props: ['mostrar', 'idExpediente', 'idActa', 'idCuenta'],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"]),
    
  },
  validations: {
    descarga:{
      folio: {required},
      giro: {required},
      
      seConsidera: {required},
      vigencia: {required},
      pie: {required},
    }
  },
  data: function() {
    return {
      enviando: false,    
      descarga:{
        folio:'',
        giro: '',
        
        seConsidera: '',
        vigencia: DateTime.now().toFormat('yyyy-MM-dd'),
        pie:''
      },
      
    };
  },
  
  
  
  methods: {
 
    guardar(){
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.enviando=true;
          
          axios({
          url: `${this.httpURL}/proteccionBomberos/cuenta/${this.idCuenta}/expediente/${this.idExpediente}/acta/descargar/${this.idActa}`,
          method: 'POST',
          responseType: 'blob', // important
          data: { 
            folio:this.descarga.folio,
            giro: this.descarga.giro,
    
            seConsidera:this.descarga.seConsidera,
            vigencia:this.descarga.vigencia,
            pie:this.descarga.pie},
          headers:{token:this.sessionToken}
          })
          .then(response => {
            
              this.enviando=false
              let blob = new Blob([response.data], { type: 'application/pdf' }),
              url = window.URL.createObjectURL(blob);
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.href = url;
              a.download = `Acta_${this.descarga.folio}.pdf`             
              a.click();
              window.URL.revokeObjectURL(url);

              this.$emit('cancelar')

              })
          .catch(error => {
              //console.log(error);
              this.enviando = false;
              
            
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                          text: error.response.data.mensaje });
            
          });
        }
    },   
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>
